<template>
    <div>
    <main role="main" style = "padding-top:0px" class="right_wrapper">
      <div>
		  <BreadCrumbHeader
          @backCalled="getBackToAccount('cancel')"
          :selectedName="currentProduct ? currentProduct.asin : 'N/A'"
		  tabCalled='Product Alert History'
		  selectedModule='Product Alert History'
        />
		  <!-- <DetailTabs/> -->
		  <!-- <div class="table_wrap"> -->
		<div>
			<Detail :clientId = "clientId" :profileId = "profileId"/>
		</div>

		  <!-- </div> -->

      </div>
    </main>
    <!-- Modal Starts -->
    </div>
</template>

<script>

import DetailTabs from '@/components/product-alerts/DetailTabs.vue'
import Detail from '@/components/product-alerts/Detail.vue'
import BreadCrumbHeader from "@/components/BreadCrumbHeader.vue";

export default {
	name:'TaggingDetails',
	data(){
		return{
			brand_name:"",
			vendorId:"",
			profileId:"",
			profileData:{},
			showData:false,
			clientId:'',
			profile_route_id:'',
			client_name:''
		}
	},
	components:{
		DetailTabs,
		Detail,
		BreadCrumbHeader
	},
	computed:{
		currentPage:{
			set(val) {
				this.$store.state.accounts.accountTab =  val;
			},
			get() {
				return this.$store.state.accounts.accountTab;
			}
		},
		currentProduct:{
			set(val) {
				this.$store.state.productAlerts.selectedProduct = val
			},
			get() {
				return this.$store.state.productAlerts.selectedProduct
			}
		},
	},
	mounted(){
		this.showData = true;
	},
	methods:{
		getBackToAccount(data){
			if (data == "cancel") {
				  this.$store.state.calledFromCancel = true;
			}
			this.$router.push({ path: "/taggingStrategy"});
		},
		navigateToEdit(){
			this.$router.push({
				path: "/addVendor" + "/" + this.clientId
			});
		}
	}
}
</script>

<style lang="scss">

</style>
